import Vue from 'vue'
import iView from 'iview'
import iviewArea from 'iview-area'
import VueResource from 'vue-resource'
import 'iview/dist/styles/iview.css'
import App from './App.vue'
import router from './router'
import store from './store'
import * as types from './store/mutation-types'
import Cookies from 'js-cookie'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(iView)
Vue.use(iviewArea)
Vue.use(VueResource)

Vue.http.interceptors.push(function (request, next) {
  if (store.state.token) {
    request.headers.set('Authorization', `Bearer ${store.state.token}`)
  }
  next()
})

let token = Cookies.get('ata')
if (token) {
  store.commit(types.SET_TOKEN, token)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js